import styled from 'styled-components';
export const NonProductContainer = styled.div`
	@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
		& .nonp-carousel-container {
			& > .nonp-carousel {
				width: 100%;
				& > .nonp {
					& ul.slider {
						padding: 0 10px !important;
					}
				}
			}
		}
	}
	@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	}
`;
